import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import "rxjs/Rx";

@Injectable()
export class ParagraphsService {
  constructor(private http: HttpClient) { }

  getParagraphs(testId) {
    return this.http.get(`/api/internalparagraphs/getParagraphs`, {
      params: { TEST_ID: testId },
      responseType: "json"
    });
  }

  getAllParagraphs() {
    return this.http.get(`/api/internalparagraphs/getAllParagraphs`, {
      responseType: "json"
    });
  }

  addParagraph(data: any) {
    return this.http.post(`/api/internalparagraphs/addParagraph`, data, {});
  }

  editParagraph(data: any) {
    return this.http.put(`/api/internalparagraphs/editParagraph`, data, {});
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/paragraphs.service.ts